import { render, staticRenderFns } from "./AutoRouterLink.vue?vue&type=template&id=67cf1df0&"
import script from "./AutoRouterLink.vue?vue&type=script&lang=js&"
export * from "./AutoRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports